export default {
    data: () => ({

    }),
    computed: {
        //Computo para obtener el total de albumes agregados al carrito
        getAlbumes: {
            get: function() {
                return this.$store.getters.Albumes;
            }
        },
        //Computo para obtener el total de Codigos de descarga | Brazaletes | Reservas agregadas
        getCodes: {
            get: function() {
                return this.$store.getters.Codes;
            }
        },
        requireReloadAlbumes: {
            get: function() {
                return this.$store.getters.needReloadAlbumes;
            }
        },
        getSpinningMultimedia: {
            get: function() {
                return this.$store.getters.SpinningMultimedia;
            }
        },
        getProgressingMultimedia: {
            get: function() {
                return this.$store.getters.ProgressingMultimedia;
            }
        },
        getCompressingMultimedia: {
            get: function() {
                return this.$store.getters.CompressingMultimedia;
            }
        },
        getDownloadedMultimedia: {
            get: function() {
                return this.$store.getters.downloadedMultimedia;
            }
        },
        getDownloadedMultimediaProgress: {
            get: function() {
                return this.$store.getters.downloadedMultimediaProgress;
            }
        },
        getCompressingZipCompressed: {
            get: function() {
                return this.$store.getters.CompressingZipCompressed;
            }
        },
        getCompressingZipTotal: {
            get: function() {
                return this.$store.getters.CompressingZipTotal;
            }
        },
        getCompletedDownload: {
            get: function() {
                return this.$store.getters.CompletedDownload;
            }
        }
    },
    methods: {
        //Funcion para remover el codigo agregado al carrito de compra
        removeItemOfAlbumes(ItemCodeRemove) {
            this.$swal({
                title: '¿Deseas eliminar el registro ' + ItemCodeRemove + '?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'var(--color-red)',
                cancelButtonColor: 'var(--color-blue)',
                confirmButtonText: '¡Si, eliminarlo!'
            }).then((result) => {
                if (result.isConfirmed) {
                    let data = this.getAlbumes;

                    if (this.getAlbumes.length) {
                        //Tenemos algo, por lo cual vamos a añadir un nuevo codigo
                        if (this.existItemInCollection(this.getAlbumes, ItemCodeRemove)) {
                            data = this.removeOfCollection(this.getAlbumes, ItemCodeRemove);
                            this.setAlbumes([]);
                            this.setAlbumes(data);
                        }
                    }
                }
            })

        },
        setAlbumes(newAlbumes) {
            return this.$store.dispatch("setAlbumes", newAlbumes);
        },
        setCodes(newCodes) {
            return this.$store.dispatch("setCodes", newCodes);
        },
        setStatusReloadAlbumes(status) {
            return this.$store.dispatch("setStatusReloadAlbumes", status);
        },
        setSpinningMultimedia(data) {
            return this.$store.dispatch("setSpinningMultimedia", data);
        },
        setProgressingMultimedia(data) {
            return this.$store.dispatch("setProgressingMultimedia", data);
        },
        setCompressingMultimedia(data) {
            return this.$store.dispatch("setCompressingMultimedia", data);
        },
        setDownloadedMultimedia(multimedia) {
            return this.$store.dispatch("setDownloadedMultimedia", multimedia);
        },
        clearDownloadedMultimedia() {
            return this.$store.dispatch("setDownloadedMultimedia", []),
                this.$store.dispatch("setDownloadProgress", 0),
                this.setCompressingZipCompressed(0),
                this.setCompressingZipTotal(0),
                this.setProgressingMultimedia(false),
                this.setCompressingMultimedia(false),
                this.setCompletedDownload(false);
        },
        setDownloadProgress(data) {
            return this.$store.dispatch("setDownloadProgress", data);
        },
        setCompressingZipCompressed(data) {
            return this.$store.dispatch("setCompressing_Zip_Compressed", data);
        },
        setCompressingZipTotal(data) {
            return this.$store.dispatch("setCompressing_Zip_Total", data);
        },
        setCompletedDownload(data) {
            return this.$store.dispatch("setCompletedDownload", data);
        },
        //Funcion que verifica si el codigo ya esta en la lista de los codigos agregados al carrito
        existItemInCollection(data, codeToFind) {
            let exist = false;
            data.map(function(item) {
                
                if (item.code == codeToFind) exist = true;
            });

            return exist;
        },
        removeOfCollection(collection, ItemCodeRemove) {
            let data = collection.filter(function(item) {
                return item.code !== ItemCodeRemove;
            });

            return data;
        }
    }
};